//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** Represents and indicates the  attendance rule to use when a Rock.Model.Person checks in to a Rock.Model.Group of this Rock.Model.GroupType */
export const AttendanceRule = {
    /**
     * None, person does not need to belong to the group, and they will not automatically 
     * be added to the group
     */
    None: 0,

    /** Person will be added to the group whenever they check-in */
    AddOnCheckIn: 1,

    /** User must already belong to the group before they will be allowed to check-in */
    AlreadyBelongs: 2
} as const;

/** Represents and indicates the  attendance rule to use when a Rock.Model.Person checks in to a Rock.Model.Group of this Rock.Model.GroupType */
export const AttendanceRuleDescription: Record<number, string> = {
    0: "None",

    1: "Add On Check In",

    2: "Already Belongs"
};

/** Represents and indicates the  attendance rule to use when a Rock.Model.Person checks in to a Rock.Model.Group of this Rock.Model.GroupType */
export type AttendanceRule = typeof AttendanceRule[keyof typeof AttendanceRule];
